import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { nbsApiSearchLocation } from '../../../store/actions/searchLocation';
import {
  resetCreateAccountData,
  setUserCreateAccountData,
} from '../../../store/actions/createAccountData';
import { nbsApiEmailRegister } from '../../../store/actions/emailRegister';
import { nbsApiEmailLogin } from '../../../store/actions/emailLogin';
import { nbsApiCheckUsername } from '../../../store/actions/checkUsername';
import { setSessionToken } from '../../../store/actions/session';
import { nbsApiTransCoregLookup } from '../../../store/actions/transCoregLookup';
import EmailRegister from '../../../components/Auth/EmailRegister/EmailRegister';
import { makeDob } from '../../../assets/helpers/dateTimeUtils';
import { gtmTrack } from '../../../assets/helpers/GAHelper';
import {
  getLandingId,
  prepareAffiliateParams,
} from '../../../assets/helpers/affiliateHelper';
import {
  getRomanceGuardParam,
  getConfigIndexValueForGenderAndSeekingBasedOnGenders,
  getGenderIdBasedOnGendersConfig,
  parseGenderAndSeekingFromUrl,
  getNewSeekingValue,
  getGenderSeekingComboByWeight,
  getOldSeekingValue,
} from '../../../assets/helpers/utils';

class EmailRegisterContainer extends Component {
  state = {
    isTransCoregOfferChecked: false,
    transCoregText: '',
    showTransCoregCheckbox: false,
    genderSeekingComboSet: false,
  };

  genderAndSeeking = undefined;
  isGenderUrlPreselected = false;

  componentDidMount() {
    const { createAccountData } = this.props;
    this.setHashTagForRoute(this.props.step);
    if (this.props.getConfig.status === 'success') {
      this.props.setUserCreateAccountData({
        minAge: this.props.getConfig.response.allowed_ages.min,
        maxAge: this.props.getConfig.response.allowed_ages.max,
      });
    }
    if (this.props.myLocation.status === 'success') {
      const { lat, place, country } = this.props.myLocation.response;
      const lon = this.props.myLocation.response.lon
        ? this.props.myLocation.response.lon
        : this.props.myLocation.response.lng;
      const locationRegEx = /undefined/gi;
      const location = locationRegEx.test(place) ? '' : place;
      this.props.setUserCreateAccountData({
        location,
        lon,
        lat,
        country,
      });
    }
    // on mount check if we got url genders params and set gender and seeking as preselected option
    // this will happen when user came to this page from index page with preselected genders
    if (
      this.props.createAccountData.areGendersPreselectedFromUrlData &&
      this.props.createAccountData.genderApiConfigDataLodaded
    ) {
      let genderSelectedIndex =
        getConfigIndexValueForGenderAndSeekingBasedOnGenders(
          createAccountData.gender,
          createAccountData.seeking
        );
      +genderSelectedIndex > 0 &&
        this.setGenderAndSeeking(
          createAccountData.gender,
          createAccountData.seeking,
          genderSelectedIndex
        );
    } else {
      this.setGenderAndSeeking(1, 2, 0);
    }
    // if we open this page directly through url link with gender url params
    if (
      this.props.history &&
      this.props.history.location &&
      this.props.history.location.search &&
      this.props.history.location.search !== '' &&
      (this.props.history.location.search.indexOf('gender') > -1 ||
        this.props.history.location.search.indexOf('seeking') > -1)
    ) {
      this.genderAndSeeking = parseGenderAndSeekingFromUrl(
        this.props.history.location.search
      );
      this.isGenderUrlPreselected = true;
      this.props.createAccountData &&
        this.props.createAccountData.areGendersPreselectedFromUrlData ===
          false &&
        this.props.setUserCreateAccountData({
          areGendersPreselectedFromUrlData: true,
        });
    }
    if (
      this.props.createAccountData.genderApiConfigDataLodaded === false &&
      this.props.getConfig.status === 'success'
    ) {
      this.props.setUserCreateAccountData({ genderApiConfigDataLodaded: true });
    }
  }

  componentDidUpdate(prevProps) {
    // Handle step change
    if (this.props.step !== prevProps.step) {
      this.setHashTagForRoute(this.props.step);
    }

    // Handle Gender Seeking Combo Update
    if (
      this.props.getConfig.status === 'success' &&
      !this.props.createAccountData.areGendersPreselectedFromUrlData &&
      !this.state.genderSeekingComboSet
    ) {
      const stats = getGenderSeekingComboByWeight(
        this.props.getConfig.response.genders_seeking_stats
      );

      let gender = this.props.createAccountData.gender || 1;
      let seeking = this.props.createAccountData.seeking || 2;
      let genderAndSeekingCombo = null;

      if (stats) {
        gender = stats.gender;
        seeking = stats.seeking;
        genderAndSeekingCombo = [
          `${stats.gender}_${stats.seeking[0]}`,
          `${stats.seeking[0]}_${stats.gender}`,
        ];
      }

      const oldSeekingValue = getOldSeekingValue(seeking);
      let genderSelectedIndex =
        getConfigIndexValueForGenderAndSeekingBasedOnGenders(
          gender,
          oldSeekingValue,
          genderAndSeekingCombo
        );

      this.setGenderAndSeeking(gender, oldSeekingValue, genderSelectedIndex);
      this.setState({ genderSeekingComboSet: true });
    }

    // Handle Email Registration Success
    if (
      this.props.emailRegister.status === 'success' &&
      prevProps.emailRegister.status !== 'success' &&
      this.props.emailRegister.fromPage === 'StepFive-modal'
    ) {
      this.setHashTagForRoute(this.props.step + 1);
      this.emailLogin();
      gtmTrack({
        event: 'sign_up',
        signup_type: 'signup_modal',
        method: 'email',
        user_id: this.props.emailRegister.response.user_id,
      });
    }

    // Handle Email Registration Failure
    if (
      this.props.emailRegister.status === 'fail' &&
      prevProps.emailRegister.status !== 'fail' &&
      this.props.emailRegister.fromPage === 'StepFive-modal'
    ) {
      gtmTrack({
        event: 'signup_error',
        message: this.props.emailRegister.error.error,
      });
    }

    // Handle Email Login Success
    if (
      this.props.emailLogin.status === 'success' &&
      prevProps.emailLogin.status !== 'success'
    ) {
      this.props.setSessionToken(this.props.emailLogin.response.token);
      this.props.resetCreateAccountData();
    }

    // Handle Email Login Failure
    if (
      this.props.emailLogin.status === 'fail' &&
      prevProps.emailLogin.status !== 'fail'
    ) {
      gtmTrack({
        event: 'signup_error',
        message: this.props.emailLogin.error.error,
      });
    }

    // Handle Gender Update After Config Fetch
    if (prevProps.getConfig.isFetching && !this.props.getConfig.isFetching) {
      const configGenders =
        this.props.getConfig.response &&
        this.props.getConfig.response.genders_singular;

      if (
        this.genderAndSeeking &&
        this.genderAndSeeking.gender &&
        this.genderAndSeeking.seeking
      ) {
        let seekingGenderFromUrl = getGenderIdBasedOnGendersConfig(
          this.genderAndSeeking,
          configGenders
        );

        if (
          seekingGenderFromUrl &&
          seekingGenderFromUrl.gender &&
          seekingGenderFromUrl.seeking
        ) {
          this.props.setUserCreateAccountData({
            gender: seekingGenderFromUrl.gender,
            seeking: seekingGenderFromUrl.seeking,
            genderApiConfigDataLodaded: true,
          });
        } else {
          this.props.setUserCreateAccountData({
            genderApiConfigDataLodaded: true,
          });
        }
      }
    }

    // Handle Pre-selected Gender & Seeking from URL
    if (
      (this.props.createAccountData.gender !==
        prevProps.createAccountData.gender ||
        this.props.createAccountData.seeking !==
          prevProps.createAccountData.seeking) &&
      this.isGenderUrlPreselected
    ) {
      let genderSelectedIndex =
        getConfigIndexValueForGenderAndSeekingBasedOnGenders(
          this.props.createAccountData.gender,
          this.props.createAccountData.seeking
        );

      if (+genderSelectedIndex > 0) {
        this.setGenderAndSeeking(
          this.props.createAccountData.gender,
          this.props.createAccountData.seeking,
          genderSelectedIndex
        );
      }
    }
  }

  setHashTagForRoute = (step, reset = false) => {
    if (!step || reset) {
      this.props.history.replace(
        this.props.history.location.pathname +
          this.props.history.location.search
      );
      return;
    }
    this.props.history.replace(
      this.props.history.location.pathname +
        this.props.history.location.search +
        '#step' +
        step
    );
  };

  setGenderAndSeeking = (gender, seeking, genderAndSeekingSelectedValue) => {
    this.props.setUserCreateAccountData({
      gender,
      seeking,
      genderAndSeekingSelectedValue,
    });
  };

  setUsername = (username) => {
    this.props.setUserCreateAccountData({ username });
  };

  setLocation = (location, lat, lon, country) => {
    this.props.setUserCreateAccountData({ location, lat, lon, country });
  };

  setAge = (age) => {
    this.props.setUserCreateAccountData({ age });
  };

  setEmail = (email) => {
    this.props.setUserCreateAccountData({ email });
  };

  setPassword = (password) => {
    this.props.setUserCreateAccountData({ password });
  };

  getTransCoreg = (email, country) => {
    this.props.nbsApiTransCoregLookup({ email, country });
  };

  toggleTransCoregOffer = () => {
    this.setState({
      isTransCoregOfferChecked: !this.state.isTransCoregOfferChecked,
    });
  };

  setTransCoreg = (show, msg) => {
    this.setState({ showTransCoregCheckbox: show, transCoregText: msg });
  };

  createAccount = () => {
    const { gender, seeking, username, email, password, age, lat, lon } =
      this.props.createAccountData;
    const dob = makeDob(age);
    const obj = {
      signup_type: 'regular',
      sex: gender,
      dob,
      age,
      email,
      password,
      lat,
      lon,
      // pref_sex: seeking,
      pref_sex: getNewSeekingValue(seeking),
      coreg: 0,
      username,
      platform: 'web',
      __RG: getRomanceGuardParam(),
    };

    const landingId = getLandingId();
    if (landingId !== '') {
      const affParams = prepareAffiliateParams({}, true);
      for (let key in affParams) {
        obj[key] = affParams[key];
      }
    }

    if (this.state.isTransCoregOfferChecked) {
      obj.trans_coreg_id = this.props.transCoregLookup.response.trans_coreg_id;
    }

    // console.log('CREATE ACCOUNT!!!!!!', obj);
    this.props.nbsApiEmailRegister(obj, 'StepFive-modal');
  };

  emailLogin = () => {
    const { email, password } = this.props.createAccountData;
    const obj = {
      email,
      password,
      login_type: 'regular',
      device_type: 3,
      __RG: getRomanceGuardParam(),
    };
    this.props.nbsApiEmailLogin(obj);
  };

  render() {
    // console.log(
    //   'EMAIL REGISTER CONTAINER RENDER:::::',
    //   this.props,
    //   this.state,
    //   this.genderAndSeeking
    // );
    return (
      <EmailRegister
        {...this.props.createAccountData}
        {...this.state}
        isGenderUrlPreselected={this.isGenderUrlPreselected}
        getConfig={this.props.getConfig}
        isLandscape={this.props.isLandscape}
        step={this.props.step}
        goToStep={this.props.goToStep}
        setGenderAndSeeking={this.setGenderAndSeeking}
        setUsername={this.setUsername}
        setLocation={this.setLocation}
        setAge={this.setAge}
        setEmail={this.setEmail}
        setPassword={this.setPassword}
        createAccount={this.createAccount}
        nbsApiSearchLocation={this.props.nbsApiSearchLocation}
        searchLocation={this.props.searchLocation}
        checkUsername={this.props.checkUsername}
        nbsApiCheckUsername={this.props.nbsApiCheckUsername}
        emailRegister={this.props.emailRegister}
        emailLogin={this.props.emailLogin}
        goBack={this.props.goBack}
        transCoregLookup={this.props.transCoregLookup}
        getTransCoreg={this.getTransCoreg}
        toggleTransCoregOffer={this.toggleTransCoregOffer}
        setTransCoreg={this.setTransCoreg}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    myLocation: state.myLocation,
    getConfig: state.getConfig,
    searchLocation: state.searchLocation,
    createAccountData: state.createAccountData,
    emailRegister: state.emailRegister,
    checkUsername: state.checkUsername,
    emailLogin: state.emailLogin,
    transCoregLookup: state.transCoregLookup,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      nbsApiSearchLocation,
      resetCreateAccountData,
      setUserCreateAccountData,
      nbsApiEmailRegister,
      nbsApiCheckUsername,
      nbsApiEmailLogin,
      setSessionToken,
      nbsApiTransCoregLookup,
    },
    dispatch
  );
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EmailRegisterContainer)
);



// WEBPACK FOOTER //
// ./src/containers/Auth/EmailRegister/EmailRegisterContainer.js